<template>
    <div class="formula">
        <b-navbar class="px-0">
            <b-navbar-brand class="m-0">
                <h4>{{ data.label }}</h4>
            </b-navbar-brand>
            <b-nav class="ml-auto" v-if="isChild">
                <b-button @click="$parent.set_variable(null)" variant="outline-primary"><base-icon name="clear" /></b-button>
            </b-nav>
        </b-navbar>
        <div class="mb-3">
            <template v-for="elem in data.formula">
                <a href="#" target="_self" v-if="elem.key" :key="elem.key" @click="set_variable(elem.key)" v-html="elem.label"></a>
                <div v-else-if="elem.formula_name" :key="elem.formula_name">
                    <img :src="formules[elem.formula_name]" />
                </div>
                <span v-else :key="elem.label" v-html="elem.label"></span>
            </template>
        </div>
            <myframe v-if="data.descs" title="Описание" expanded :visible="false" without_border>
                <b-table :fields="fields" :items="data.descs" thead-class="d-none" class="mt-2">
                    <template v-slot:cell()="data">
                        <span v-html="data.value"></span>
                    </template>
                </b-table>
            </myframe>
            <formula ref="child" v-if="variable" :data="data.variables[variable]" isChild />
    </div>
</template>

<script>
import myframe from "../../../../../widgets/frame"
import residential from "./formules/residential.svg"
import non_residential_1 from "./formules/non_residential_1.svg"
import non_residential_2 from "./formules/non_residential_2.svg"
import non_residential_3 from "./formules/non_residential_3.svg"

export default
{
    name : "formula",
    props:
    {
        data : Object,
        isChild : { type : Boolean, default : () => false },
    },

    components :
    {
        myframe
    },

    data() {
        return {
            variable : null,

            fields :
            [
                { key : "name", label : "", tdClass : "formula_cell", },
                { key : "desc", label : "", tdClass : "formula_cell", }
            ],

            formules:
            {
                residential,
                non_residential_1,
                non_residential_2,
                non_residential_3
            },
        }
    },

    methods :
    {
        set_variable(value)
        {
            if (this.variable) this.$refs.child.set_variable(null)
            this.variable = value
        },
    }
}
</script>

<style>
.formula_cell
{
	width: 50%;
}
</style>
